/*
 * Returns the scrollTop of the window.
 */
var scrollTop = function scrollTop() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};

export default scrollTop;